import { gql } from '@apollo/client';

import { ContactFragment } from 'src/graphql/actions/contact/contact.fragment';

export const BeneficiaryPolicyFragment = gql`
  fragment BeneficiaryPolicyFragment on BeneficiaryPolicy {
    readEscrowMembers
    update
    createEscrowMembers
  }
`;

export const BeneficiaryFields = gql`
  ${ContactFragment}
  ${BeneficiaryPolicyFragment}
  fragment BeneficiaryFields on Beneficiary {
    city
    companyName
    companyRegistrationNumber
    companyWebsite
    country
    id
    postalCode
    region
    street
    streetNumber
    contacts {
      ...ContactFragment
    }
    policy {
      ...BeneficiaryPolicyFragment
    }
  }
`;
